const KEY = 'operator-workspace.crm-tab'

export function crmTabSession() {
    try { return JSON.parse(sessionStorage.getItem(KEY)) || null } catch (_) { return null }
}
export function isCrmTab() { return !!crmTabSession() }
export function saveCrmTabSession(companyId, headers) {
    sessionStorage.setItem(KEY, JSON.stringify({ companyId: Number(companyId), headers }))
}
export function readStoredAuth() {
    const isolated = crmTabSession()
    if (isolated) return isolated.headers
    try { return JSON.parse(localStorage.getItem('common')) } catch (_) { return null }
}
export function saveStoredAuth(headers) {
    const isolated = crmTabSession()
    if (isolated) saveCrmTabSession(isolated.companyId, headers)
    else localStorage.setItem('common', JSON.stringify(headers))
}
export function clearStoredAuth() {
    const isolated = crmTabSession()
    if (isolated) saveCrmTabSession(isolated.companyId, null)
    else localStorage.removeItem('common')
}
